import { IState } from "..";
import { createSlice } from "@reduxjs/toolkit";
import { AppThunk } from "../../app/store";
import TerminalService from "../../app/data/terminal-details/terminalService";
import { initialUpdateContactState } from "./ContactState";
import { UpdateContact } from "../../app/data/terminal-details/models";

const terminalService = TerminalService.getInstance();

export const updateContactSlice = createSlice({
    name: "updateContact",
    initialState: initialUpdateContactState,
    reducers: {
        loading: (state) => {
            state.isLoading = true;
            state.isSuccess = false;
            state.isError = false;
            state.errorMessage = null;
        },
        setContact: (state, { payload }) => {
            state.data = payload;
            state.isLoading = false;
            state.isError = false;
            state.isSuccess = true;
            state.errorMessage = null;
        },
        error: (state, { payload }) => {
            state.isLoading = false;
            state.isError = true;
            state.isSuccess = false;
            state.errorMessage = payload;
        }
    },
});

export const {
    loading,
    setContact,
    error
} = updateContactSlice.actions;

export const updateContactSelector = (state: IState) => state.updateContact;

// update terminal contact by contact id
export const updateTerminalContactById = (terminalNumber: string, contactId: string, data: UpdateContact, onSuccess?: () => void, onError?: (message: string | object) => void): AppThunk => async (dispatch) => {
    if (!contactId) return
    dispatch(loading());
    const response = await terminalService.updateTerminalContactById(terminalNumber, contactId, data);
    if (response.ok()) {
        dispatch(setContact(response.data));
        onSuccess?.();
    } else {
        dispatch(error(response.getError()));
        if(typeof response.getError() === "string" && response.getError() !== "")
            onError?.(response?.getError() || "Error! Please try again later...");
        else
            onError?.("Error! Please try again later...");
    }
};

const updateContactReducer = updateContactSlice.reducer;
export default updateContactReducer;
